import { useState } from 'react';
import { api } from '../api';

export default function InsightCard({ onGenerated }) {
  const [generating, setGenerating] = useState(false);

  const handleGenerate = async () => {
    setGenerating(true);
    try {
      await api.post('/notifications/generate-insight');
      if (onGenerated) onGenerated();
    } catch (e) {
      console.error('Failed to generate insight', e);
    } finally {
      setGenerating(false);
    }
  };

  return (
    <button
      style={cardStyles.btn}
      onClick={handleGenerate}
      disabled={generating}
    >
      <span style={cardStyles.icon}>✨</span>
      <span style={cardStyles.label}>
        {generating ? 'Analyzing...' : 'Get AI Insight'}
      </span>
    </button>
  );
}

const cardStyles = {
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    padding: '6px 12px',
    backgroundColor: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: 20,
    cursor: 'pointer',
  },
  icon: {
    fontSize: 13,
  },
  label: {
    fontSize: 13,
    fontWeight: 500,
    color: '#64748b',
  },
};